var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(!_vm.isPersonal)?_c('project-config-boards',{staticClass:"mb-5"}):_vm._e(),_c('project-config-approvals',{staticClass:"mb-5"}),_c('project-config-status',{staticClass:"mb-5",on:{"saved":_vm.init}}),_c('project-config-tags',{staticClass:"mb-5",on:{"saved":_vm.init}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }